function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Onboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-/-Menu",
  transform: "translate(-26.000000, -247.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Budget",
  transform: "translate(0.000000, 224.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu-/-Icon-box",
  transform: "translate(20.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-/-Cloud-tile-/-Azure",
  transform: "translate(5.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "GCP-logo",
  transform: "translate(1.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.425195,3.98656269 L11.9737253,3.98656269 L13.5372525,2.42303539 L13.6139172,1.75896821 C10.7038992,-0.809838032 6.26274745,-0.532333533 3.69394121,2.37768446 C2.98020396,3.18536293 2.4629874,4.14745051 2.18008398,5.18836233 C2.35392921,5.11709658 2.54721056,5.10521896 2.72861428,5.15596881 L5.85566887,4.63983203 C5.85566887,4.63983203 6.01439712,4.37636473 6.09754049,4.39256149 C7.48830234,2.86466707 9.82927415,2.6865027 11.4359928,3.98656269 L11.425195,3.98656269 Z",
  id: "Path",
  fill: "#EA4335"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.764847,5.18836233 C15.4052789,3.86454709 14.6677864,2.67462507 13.6419916,1.76544691 L11.4478704,3.95956809 C12.3743251,4.7164967 12.9023395,5.85782843 12.8796641,7.05422915 L12.8796641,7.44403119 C13.9583683,7.44403119 14.8329934,8.31865627 14.8329934,9.39736053 C14.8329934,10.4760648 13.9583683,11.3506899 12.8796641,11.3506899 L8.9730054,11.3506899 L8.58320336,11.7458908 L8.58320336,14.0890222 L8.9730054,14.4788242 L12.8796641,14.4788242 C15.684943,14.5004199 17.9773245,12.2436713 17.9989202,9.43839232 C18.0118776,7.7344931 17.1728854,6.14073185 15.764847,5.18836233 Z",
  id: "Path",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.06094781,14.4539892 L8.96760648,14.4539892 L8.96760648,11.3269346 L5.06094781,11.3269346 C4.78236353,11.3269346 4.50809838,11.2664667 4.25434913,11.1509298 L3.70581884,11.3215357 L2.1314937,12.885063 L1.99436113,13.4335933 C2.87654469,14.1008998 3.95416917,14.4593881 5.06094781,14.4539892 Z",
  id: "Path",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.06094781,4.31041379 C2.25458908,4.32669466 -0.00539892022,6.61475705 0.0106257251,9.42111578 C0.0205158968,10.9878824 0.751529694,12.4628674 1.99436113,13.4173965 L4.25974805,11.1520096 C3.27714457,10.7082184 2.83983203,9.55068986 3.28362328,8.56808638 C3.72741452,7.5854829 4.88494301,7.14817037 5.86754649,7.59196161 C6.30053989,7.78740252 6.64715057,8.13509298 6.84367127,8.56808638 L9.10905819,6.30269946 C8.14589082,5.0415117 6.64715057,4.3040192 5.06094781,4.31041379 Z",
  id: "Path",
  fill: "#FBBC05"
})))))));

function SvgGcpLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DD763BE6-F5F8-4822-B7E5-9839B10E3A72") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpLogo);
export default __webpack_public_path__ + "static/media/GCP_logo.552169bd.svg";
export { ForwardRef as ReactComponent };